function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#2C2C2C",
  fillRule: "evenodd",
  d: "M31.0011679,10.1770661 L38.3077888,0 L50.2882017,16.6819335 L50.2886079,16.6824384 L62,32.9898 L14.6154761,33 L14.6182181,32.9962634 L0,33 L23.6922112,0 L31.0011679,10.1770661 Z M5.91967607,29.9690879 L16.7230595,29.9667651 L29.0751659,12.7082797 L23.692719,5.21360917 C17.7683713,13.4654017 11.8440237,21.7171943 5.91967607,29.9690879 Z M27.392288,20.4178569 L20.6095924,29.9690879 L31.5055946,29.9666641 L43.7241553,12.755038 L38.308195,5.21360917 L27.392288,20.4178569 Z M47.820299,18.4586507 L45.5706393,15.4074396 C42.1255686,20.2602115 38.6804979,25.1130843 35.2355287,29.9658562 L56.0812379,29.9614126 L47.820299,18.4586507 Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 62,
    height: 33,
    viewBox: "0 0 62 33"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/logo.6c503b6e.svg";
export { SvgComponent as ReactComponent };